import React from 'react';
import { Box, Text, Group, Tooltip, Anchor, Badge } from '@mantine/core';
import { FieldLabelWithRequired } from './renderDynamicField';

export interface DeferredArrayRefStubFieldProps {
    fieldName: string;
    fieldLabel: string;
    readOnly: boolean;
    pendingAddsCount: number;
    pendingRemovesCount: number;
    onView: () => void;
    onAddItems?: () => void;
    onRemoveItems?: () => void;
}

/** Stub row for deferred large array-ref attributes (Not loaded* / View / Add / Remove). */
export const DeferredArrayRefStubField: React.FC<DeferredArrayRefStubFieldProps> = ({
    fieldName,
    fieldLabel,
    readOnly,
    pendingAddsCount,
    pendingRemovesCount,
    onView,
    onAddItems,
    onRemoveItems,
}) => (
    <Box key={fieldName} mb="md">
        <Text size="sm" fw={500} mb={4}>
            <FieldLabelWithRequired label={fieldLabel} required={false} readOnly={readOnly} />
        </Text>
        <Group gap="xs" align="center" wrap="wrap">
            <Tooltip label="Large reference list (paginated view)">
                <Text component="span" size="sm" c="dimmed">
                    Not loaded*
                </Text>
            </Tooltip>
            <Anchor component="button" type="button" size="sm" c="dimmed" onClick={onView}>
                View
            </Anchor>
            {!readOnly && onAddItems && onRemoveItems && (
                <>
                    <Anchor component="button" type="button" size="sm" c="dimmed" onClick={onAddItems}>
                        Add items
                    </Anchor>
                    <Anchor component="button" type="button" size="sm" c="dimmed" onClick={onRemoveItems}>
                        Remove items
                    </Anchor>
                </>
            )}
            {pendingAddsCount > 0 && (
                <Badge size="sm" variant="light" color="green">{pendingAddsCount} to add</Badge>
            )}
            {pendingRemovesCount > 0 && (
                <Badge size="sm" variant="light" color="red">{pendingRemovesCount} to remove</Badge>
            )}
        </Group>
    </Box>
);
